"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NexusNode = exports.NexusNodeDataStatus = void 0;
const nexus_node_mesh_1 = require("./nexus-node-mesh");
var NexusNodeDataStatus;
(function (NexusNodeDataStatus) {
    NexusNodeDataStatus[NexusNodeDataStatus["ABSENT"] = 0] = "ABSENT";
    NexusNodeDataStatus[NexusNodeDataStatus["PRESENT"] = 1] = "PRESENT";
    NexusNodeDataStatus[NexusNodeDataStatus["PENDING"] = 2] = "PENDING";
})(NexusNodeDataStatus = exports.NexusNodeDataStatus || (exports.NexusNodeDataStatus = {}));
class NexusNode {
    constructor(id, offset, vertices, faces, error, sphere, firstPatch, patches = []) {
        this.id = id;
        this.offset = offset;
        this.vertices = vertices;
        this.faces = faces;
        this.error = error;
        this.sphere = sphere;
        this.firstPatch = firstPatch;
        this.patches = patches;
        this._size = 0;
        /** Whether this is the sink node. */
        this.sink = false;
        this.root = true;
        this.mesh = new nexus_node_mesh_1.NexusNodeMesh();
        this.renderState = { frame: 0, error: 0 };
    }
    /**
     * All patches on the same node use the same texture.
     */
    get texture() {
        return this.patches[0].texture;
    }
    get status() {
        if (this.mesh.status === NexusNodeDataStatus.PRESENT && this.texture.status === NexusNodeDataStatus.PRESENT) {
            return NexusNodeDataStatus.PRESENT;
        }
        else if (this.mesh.status === NexusNodeDataStatus.ABSENT || this.texture.status === NexusNodeDataStatus.ABSENT) {
            return NexusNodeDataStatus.ABSENT;
        }
        return NexusNodeDataStatus.PENDING;
    }
    get size() {
        return this._size;
    }
    computeAndUpdateNodeSize(vertexBaseSize, faceBaseSize) {
        const vertexSize = vertexBaseSize * this.vertices;
        const facesSize = faceBaseSize * this.faces;
        const texturesSize = this.estimateNodeTexturesSize();
        this._size = vertexSize + facesSize + texturesSize;
    }
    // original text: 'problem: I have no idea how much space a texture is needed in GPU. 10x factor assumed.'
    estimateNodeTexturesSize() {
        if (!this.patches.length) {
            return 0;
        }
        const nodeTexturesSizeSum = this.patches
            .map(patch => patch.texture.size || 0)
            .reduce((sum, size) => sum + size);
        const nodeTexturesCount = this.patches.length;
        return 10 * nodeTexturesSizeSum / nodeTexturesCount;
    }
}
exports.NexusNode = NexusNode;
